import React from 'react'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import 'react-photo-view/dist/react-photo-view.css'
import Navbar from './component/navbar'
import Footer from './component/footer'
import AdvertisingDescription from './advertising'
import { PWA_DEHVAND_APP_URL, SERVER_URL } from './../globalDef'
import './home.css'

const img = {
    logo: require("./../assets/images/logo/logo.png"),
    bazaarIcon: require("./../assets/images/act/bazaar.png"),
    iosIcon: require("./../assets/images/act/ios.png"),
    bulletin: require("./../assets/images/mainPageImage/bulletin.png"),
    bazaar: require("./../assets/images/mainPageImage/bazaar.png"),
    bill: require("./../assets/images/mainPageImage/bill.png"),
    profile: require("./../assets/images/mainPageImage/profile.png"),
    shop: require("./../assets/images/mainPageImage/shop.png"),
}

const features = [
    { icon: 'newspaper', title: 'تابلو اعلانات روستا', text: 'دهیار و نماینده دهیاری می‌تونه اهالی رو در جریان جدیدترین اعلانات، اخبار و اطلاعیه‌های عمومی قرار بده.' },
    { icon: 'campaign', title: 'اطلاعیه‌ها و گفتگوها', text: 'خیلی راحت یه گفتگو بساز و درباره مشکلات روستا صحبت کن، یا اطلاعیه‌های ترحیم و تبریک رو در معرض دید همه بگذار.' },
    { icon: 'storefront', title: 'بازار روستا', text: 'هرچه می‌خوای از بازار روستا بخر و هرچه نیاز نداری بفروش. صاحب کسب‌وکاری؟ با ایجاد فروشگاه، خودت رو معرفی کن.' },
    { icon: 'receipt_long', title: 'قبوض روستا', text: 'قبوض روستا مثل جمع‌آوری زباله رو راحت و مطمئن پرداخت کن و تاریخچه پرداخت‌های قبلی‌ات رو ببین.' },
]
const screens = [
    { src: img.bulletin, alt: 'تابلو اعلانات' },
    { src: img.bazaar, alt: 'بازار روستا' },
    { src: img.bill, alt: 'قبوض' },
    { src: img.profile, alt: 'پروفایل' },
]
const APK_URL = `${SERVER_URL}static/application/dehvand.apk`

const Home = () => (
    <div className="dv">
        <Navbar />

        <div className="hero">
            <div className="wrap">
                <div>
                    <span className="badge">شبکه اجتماعی روستایی</span>
                    <h3  style={{fontWeight:"bold" , color:"#456e7a"}}>چه حالی می‌ده وقتی از همه اخبار روستا باخبری!<br />با <b style={{color:"#e57373"}}>ده‌وند</b> همیشه توی روستا <em style={{color:"#e57373"}}>online</em> باش</h3>
                    <p className="lead">پیام از دهیاری , گفتگو با اهالی، بازار خرید و فروش و پرداخت قبوض روستا؛ همه در یک اپلیکیشن.</p>
                    <div className="cta">
                        <a className="btn" href={APK_URL}><img src={img.logo} alt="" />دانلود مستقیم</a>
                        <span className="btn alt off"><img src={img.bazaarIcon} alt="" />دانلود از بازار</span>
                        <a className="btn alt" href={PWA_DEHVAND_APP_URL} target="_blank" rel="noopener noreferrer"><img src={img.iosIcon} alt="" />وب اپلیکیشن</a>
                    </div>
                </div>
                <div className="phones " style={{}}>
                    <div className="phone b" style={{}}><img src={img.bazaar} alt="" /></div>
                    <div className="phone c"><img src={img.bill} alt="" /></div>
                    <div className="phone a"><img src={img.bulletin} alt="" /></div>
                </div>
            </div>
        </div>

        <section id="features">
            <div className="wrap">
                <div className="title"><span>چرا ده‌وند؟</span><h3 style={{fontWeight:"bold"}}>امکانات و ویژگی‌های ده‌وند</h3></div>
                <div className="grid">
                    {features.map(f => (
                        <div className="card" key={f.icon}>
                            <div className="ic"><span className="material-icons">{f.icon}</span></div>
                            <h3 style={{fontWeight:"bold" , color:"#009688"}}>{f.title}</h3>
                            <p>{f.text}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>

        <section className="tint">
            <div className="wrap">
                <div className="title"><small>نگاهی به اپلیکیشن</small><h3 style={{fontWeight:"bold" , color:"#456e7a"}}>محیطی ساده و روان</h3></div>
                <PhotoProvider>
                    <div className="shots">
                        {screens.map(s => (
                            <PhotoView key={s.alt} src={s.src}><img src={s.src} alt={s.alt} /></PhotoView>
                        ))}
                    </div>
                </PhotoProvider>
            </div>
        </section>

        <section id="shop" className="shop">
            <div className="wrap split">
                <div>
                    <span className="kicker">برای کسب‌وکارها</span>
                    <h3 style={{fontWeight:"bold" , color:"#456e7a"}} >ایجاد فروشگاه در ده‌وند</h3>
                    <p>می‌تونی با ایجاد فروشگاه در ده‌وند، کالا و خدمات خودت رو در معرض دید اهالی روستا قرار بدی و با دسته‌بندی و مدیریت محصولات، به کار و کاسبی‌ات در سطح روستا رونق بهتری بدی.</p>
                    <p style={{ color: "var(--primary)", fontWeight: 700 }}>«ما باهاتیم… شروع کن»</p>
                </div>
                <img src={img.shop} alt="فروشگاه در ده‌وند" />
            </div>
        </section>

        <AdvertisingDescription />

        <section>
            <div className="wrap">
                <div className="band">
                    <h4 style={{ }}>همین حالا به  <b style={{color:"#fff9c4" , fontSize:26}}>ده وند </b>روستای خودت وصل شو</h4>
                    <div>ده‌ وند رو نصب کن و از همهٔ اخبار روستا باخبر باش.</div>
                    <a className="btn" href={APK_URL}>دانلود ده‌وند</a>
                </div>
            </div>
        </section>

        <Footer />
    </div>
)

export default Home
